import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import React, { useEffect, useRef, useState } from 'react';
// import WaveSurfer from 'wavesurfer.js';
// import { Play, Pause } from 'lucide-react';
// interface AudioWaveformProps {
//   mediaUrl: string;
//   onError: () => void;
// }
// const AudioWaveform = ({ mediaUrl, onError }: AudioWaveformProps) => {
//   const [waveSurfer, setWaveSurfer] = useState<WaveSurfer | null>(null);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const waveformRef = useRef(null);
//   useEffect(() => {
//     if (!mediaUrl || !waveformRef.current) return;
//     const ws = WaveSurfer.create({
//       container: waveformRef.current,
//       waveColor: '#D0D5DD',
//       progressColor: '#9CA3AF',
//       cursorColor: '#6B7280',
//       barWidth: 2,
//       barRadius: 3,
//       cursorWidth: 2,
//       height: 64,
//       barGap: 2,
//       normalize: true,
//       url: mediaUrl,
//       peaks: undefined,
//       minPxPerSec: 100,
//       fillParent: true,
//       interact: true,
//       hideScrollbar: false,
//       autoCenter: true,
//       barHeight: 0.9,
//       mediaControls: false,
//     });
//     setWaveSurfer(ws);
//     ws.on('play', () => setIsPlaying(true));
//     ws.on('pause', () => setIsPlaying(false));
//     ws.on('error', () => {
//       onError();
//     });
//     return () => {
//       ws.destroy();
//     };
//   }, [mediaUrl, onError]);
//   const togglePlayPause = () => {
//     waveSurfer?.playPause();
//   };
//   return (
//     <div className="w-full rounded-xl bg-white border border-gray-200">
//       <div className="flex items-center gap-4 px-4 py-3">
//         <button
//           onClick={togglePlayPause}
//           className="p-4 rounded-full hover:bg-gray-100 transition-colors"
//         >
//           {isPlaying ? (
//             <Pause className="w-5 h-5 text-gray-700" />
//           ) : (
//             <Play className="w-5 h-5 text-gray-700" />
//           )}
//         </button>
//         <div ref={waveformRef} className="w-10/12 h-16 bg-gray-50" />
//       </div>
//     </div>
//   );
// };
// export default AudioWaveform;
import React, { useEffect, useRef, useState } from 'react';
import WaveSurfer from 'wavesurfer.js';
import { Play, Pause, Loader2 } from 'lucide-react';
const AudioWaveformPreview = ({ mediaUrl, onError }) => {
    const [waveSurfer, setWaveSurfer] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const waveformRef = useRef(null);
    useEffect(() => {
        if (!mediaUrl || !waveformRef.current)
            return;
        setIsLoading(true);
        const ws = WaveSurfer.create({
            container: waveformRef.current,
            waveColor: '#D0D5DD',
            progressColor: '#9CA3AF',
            cursorColor: '#6B7280',
            barWidth: 2,
            barRadius: 3,
            cursorWidth: 2,
            height: 64,
            barGap: 2,
            normalize: true,
            url: mediaUrl,
            peaks: undefined,
            minPxPerSec: 100,
            fillParent: true,
            interact: true,
            hideScrollbar: false,
            autoCenter: true,
            barHeight: 0.9,
            mediaControls: false,
        });
        setWaveSurfer(ws);
        ws.on('ready', () => setIsLoading(false));
        ws.on('play', () => setIsPlaying(true));
        ws.on('pause', () => setIsPlaying(false));
        ws.on('error', () => {
            setIsLoading(false);
            onError();
        });
        return () => {
            ws.destroy();
        };
    }, [mediaUrl, onError]);
    const togglePlayPause = () => {
        waveSurfer?.playPause();
    };
    return (_jsx("div", { className: "w-full rounded-xl bg-white border border-gray-200 overflow-x-auto", children: _jsxs("div", { className: "flex items-center gap-4 px-4 py-3 overflow-x-auto", children: [_jsx("button", { onClick: togglePlayPause, className: "p-4 rounded-full hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed", disabled: isLoading, children: isLoading ? (_jsx(Loader2, { className: "w-5 h-5 text-gray-700 animate-spin" })) : isPlaying ? (_jsx(Pause, { className: "w-5 h-5 text-gray-700" })) : (_jsx(Play, { className: "w-5 h-5 text-gray-700" })) }), _jsxs("div", { className: "relative w-full pr-1 overflow-x-auto overflow-y-hidden", children: [_jsx("div", { ref: waveformRef, className: "h-16 bg-gray-50 w-full pr-1 overflow-x-auto overflow-y-hidden" }), isLoading && (_jsx("div", { className: "absolute inset-0 flex items-center justify-center bg-gray-50 bg-opacity-75 w-full", children: _jsx("span", { className: "text-sm text-gray-500", children: "Loading audio..." }) }))] })] }) }));
};
export default AudioWaveformPreview;
